<section id="profile-info">
    <div class="row">
        <div class="col-md-4">
            <div class="form-group">
                <label for="rating">Rating</label>
                <input class="form-control" id="rating" type="text"
                       [(ngModel)]="data.rating" name="rating">
            </div>
        </div>
        <div class="col-md-4">
            <div class="form-group">
                <label for="review_count">Review Count</label>
                <input class="form-control" id="review_count" type="number"
                       [(ngModel)]="data.review_count" name="review_count">
            </div>
        </div>
        <div class="col-md-4">
            <div class="form-group">
                <label for="placement_score">Placement Score</label>
                <input class="form-control" id="placement_score" type="text"
                       placeholder="e.g. 8.8/10"
                       [(ngModel)]="data.placement_score" name="placement_score">
            </div>
        </div>
        <div class="col-md-4">
            <div class="form-group">
                <label for="placement_rate">Placement Rate</label>
                <input class="form-control" id="placement_rate" type="text"
                       placeholder="e.g. 95%"
                       [(ngModel)]="data.placement_rate" name="placement_rate">
            </div>
        </div>
        <div class="col-md-4">
            <div class="form-group">
                <label for="recruiters_count">Recruiters Count</label>
                <input class="form-control" id="recruiters_count" type="text"
                       placeholder="e.g. 500+"
                       [(ngModel)]="data.recruiters_count" name="recruiters_count">
            </div>
        </div>
        <div class="col-md-4">
            <div class="form-group">
                <label for="average_salary">Average Salary</label>
                <input class="form-control" id="average_salary" type="text"
                       placeholder="e.g. ₹6.5 LPA"
                       [(ngModel)]="data.average_salary" name="average_salary">
            </div>
        </div>
        <div class="col-md-4">
            <div class="form-group">
                <label for="highest_package">Highest Package</label>
                <input class="form-control" id="highest_package" type="text"
                       placeholder="e.g. ₹54 LPA"
                       [(ngModel)]="data.highest_package" name="highest_package">
            </div>
        </div>
        <div class="col-md-4">
            <div class="form-group">
                <label for="scholarship">Scholarship</label>
                <input class="form-control" id="scholarship" type="text"
                       placeholder="e.g. Up to 75%"
                       [(ngModel)]="data.scholarship" name="scholarship">
            </div>
        </div>
        <div class="col-md-4">
            <div class="form-group">
                <label for="annual_fees">Annual Fees</label>
                <input class="form-control" id="annual_fees" type="text"
                       placeholder="e.g. ₹1.60 L"
                       [(ngModel)]="data.annual_fees" name="annual_fees">
            </div>
        </div>
        <div class="col-md-4">
            <div class="form-group">
                <label for="emi_starting">EMI Starting</label>
                <input class="form-control" id="emi_starting" type="text"
                       placeholder="e.g. ₹2,999/Month"
                       [(ngModel)]="data.emi_starting" name="emi_starting">
            </div>
        </div>
        <div class="col-12">
            <div class="form-group">
                <label for="ai_summary">AI Summary</label>
                <textarea class="form-control" id="ai_summary" rows="2"
                          [(ngModel)]="data.ai_summary" name="ai_summary"></textarea>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group form-check">
                <input type="checkbox" class="form-check-input" id="ai_recommended"
                       [(ngModel)]="data.ai_recommended" name="ai_recommended">
                <label class="form-check-label" for="ai_recommended">AI
                    Recommended</label>
            </div>
        </div>
    </div>
    <div class="text-right">
        <button class="btn btn-primary" rippleEffect (click)="submit()"
                [disabled]="submitting">
            <i class="fas fa-spinner fa-pulse mr-1" *ngIf="submitting"></i>
            <span class="font-weight-bold">Submit</span>
        </button>
    </div>
</section>
